import { useState } from "react";
import { useAppContext } from "../../../../context/AuthContext";
import { Lecture } from "../../../../controller";
import LectureDto from "../../../../interfaces/lecture/LectureDto";
import { useEffectOnce, isLectureLive, isLectureFuture } from "../../../../utils/Utils";
import Routes from "../../../../utils/Routes";
import EnumTabs from "../../../../utils/enum/EnumTabs";
import { useHistory } from "react-router-dom";
interface MyLecturesServiceType {
  lectures: Array<LectureDto>;
}

export default function MyLecturesService(): MyLecturesServiceType {
  const { selectedCourse } = useAppContext();
  const [lectures, setLectures] = useState<Array<LectureDto>>([]);
  const history = useHistory();
  useEffectOnce(() => {
    getLectures();    
  });

  const tryNavigateToForum = (lectures: Array<LectureDto>) => {
    console.log("tryNavigateToForum", lectures.length);
    if (lectures?.length > 0) {

      const liveLecture = lectures.filter((l: LectureDto) => isLectureLive(l));
      let lectureNum;
      if (liveLecture.length > 0) {
        lectureNum = liveLecture[0].lectureNum;
      } else {
        const endedLecture = lectures.filter((l: LectureDto) => !isLectureLive(l) &&
          !isLectureFuture({ startTime: l.startTime, endTime: l.endTime }));
        if (endedLecture.length > 0) {
          lectureNum = endedLecture[endedLecture.length - 1].lectureNum;

        }
      }
      
      if (lectureNum) {
        history.push({
          pathname: Routes.LECTURE_LIVE.replace(":lectureNum", String(lectureNum)),
          state: { lectureNum: lectureNum, goToTab: EnumTabs.Q_A },
        });
      }
    }
  }

  const getLectures = () => {
    Lecture.getCourseLectures(selectedCourse.id)
      .then(({ data }: any) => {
        if (data?.message) {
          setLectures(data.data);    
        } else {
          console.error(data);
        }
      })
      .catch((err) => console.error(err));
  };

  return { lectures };
}

export type { MyLecturesServiceType };
